module.exports = __webpack_public_path__ + "img/costal-5-3.8f304a08.jpg";